module.exports = __webpack_public_path__ + "img/xinxijianshe1.231d056e.png";